import { RectPickerBase } from "../common/rect-picker-base";

export class DefaultMathRectPicker extends RectPickerBase {
    constructor(canvasRenderer) {
        super(), this.canvasRenderer = canvasRenderer;
    }
}
//# sourceMappingURL=rect-picker.js.map
